/* eslint-disable no-unused-expressions */
import moment from 'moment';
import Geocode from 'react-geocode';
import _ from 'underscore';
var momentDurationFormatSetup = require('moment-duration-format');
momentDurationFormatSetup(moment);
typeof moment.duration.fn.format === 'function';
// true
typeof moment.duration.format === 'function';
// true

export const currencyFormat = (value, usingText = false) => {
  let txt = usingText ? `${usingText} ` : '';

  return `${txt}${new Intl.NumberFormat('de-DE').format(value)}`;
};

export const stdWeekDayInd = (values) => {
  var results = [];

  _.each(values, function(v) {
    var res;

    switch(v) {
    case "Monday":
      res = "Senin";
      break;
    case "Tuesday":
      res = "Selasa";
      break;
    case "Wednesday":
      res = "Rabu";
      break;
    case "Thursday":
      res = "Kamis";
      break;
    case "Friday":
      res = "Jumat";
      break;
    case "Saturday":
      res = "Sabtu"
      break;
    default:
      res = "Minggu";
    }

    results.push(res)
  })

  return results.join(', ')
}


export const formatDate = (v, format = 'DD/MM/YYYY HH:mm') => {
  const date = moment(v);

  const year = date.format('YYYY');
  if (year === '0001' || year === '1970') {
    return '-';
  }

  return date.format(format);
};

export const isNotClient = (scid, cid) => {
  return scid !== cid;
}

export const UTCFormat = (date, time, withHour = false) => {
  const tz = moment().format('Z');

  let hour = time;
  if (time === '' && withHour) {
    hour = '23:59';
  }

  if (date !== '') {
    // return `${date}T${hour}:00${tz}`
    return `${date} ${hour} ${tz}`;
  }else{
    // return `${hour}:00${tz}`
    return `${hour} ${tz}`;
  }
};

export const diffDate = (s, e) => {
  return moment(e).diff(s, 'days')
}

export const durationFormat = (v) => {
  let a = v / 1000000;
  var invalid = moment.duration(a, 'second');

  if (invalid.isValid()) {
    let customFormat = 'w [Minggu] d [Hari] h [Jam] m [Menit]';

    return moment.duration(a, 'milliseconds').format(customFormat);
  }

  return;
};

export const isValidDate = (v) => {
  let x = formatDate(v, 'YYYY');
  return x === '0001' || x === '1970' || x === '-' ? false : true;
};

export const isLate = (e, a) => {
  const x = new Date(e);
  const y = new Date(a);

  return y > x;
};

export const isNewest = (v) => {
  return parseFloat(moment(v).format('x')) > Date.now() - 604800000;
};

export const decimalFormat = (v) => {
  let cbm = v;

  const itg = Math.floor(v);
  const decimal = v - itg;

  if (decimal <= 0.3) {
    if (itg < 1) {
      cbm = 1;
    } else {
      cbm = itg;
    }
  } else {
    cbm = itg + 1;
  }

  return cbm;
};

export const formatPhone = (v) => {
  let format = false;

  let first = v?.substring(0, 2);

  if (v) {
    if ((first !== '08' && first !== '62') || v?.length < 10) {
      format = false;
    } else {
      format = true;
    }
  }
  return format;
};

export const waFormat = (v) => {
  const formatted = formatPhone(v);
  let val = v;
  let first = v?.substring(0, 1);

  if (v && formatted === true) {
    if (first === '0') {
      val = v?.replace('0', '62');
    } else {
      val = v;
    }
  }
  return val;
};

export const formatLatLng = async (value) => {
  const a = await Geocode.fromAddress(value);

  let pos = {};

  if (a?.status === 'OK') {
    pos = {
      lat: a.results[0].geometry.location.lat,
      lng: a.results[0].geometry.location.lng,
    };
  }

  return pos;
};

export const getQueryToken = () => {
  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());

  let token = params['asset_type'];

  return typeof token === 'undefined' ? null : token;
};

export const getQueryString = () => {
  const urlSearchParams = new URLSearchParams(window.location.search);

  return Object.fromEntries(urlSearchParams.entries());
};

export const logo64 = () => {
  const logo =
    'data:image/png;base64,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';

  return logo;
};

export const isValid = (val) => {
  const regexp = /^\d{0,2}?:?\d{0,2}$/;

  const [hoursStr, minutesStr] = val.split(':');

  if (!regexp.test(val)) {
    return false;
  }

  const hours = Number(hoursStr);
  const minutes = Number(minutesStr);

  const isValidHour = (hour) =>
    Number.isInteger(hour) && hour >= 0 && hour < 24;
  const isValidMinutes = (minutes) =>
    (Number.isInteger(minutes) && hours >= 0 && hours < 24) ||
    Number.isNaN(minutes);

  if (!isValidHour(hours) || !isValidMinutes(minutes)) {
    return false;
  }

  if (minutes < 10 && Number(minutesStr[0]) > 5) {
    return false;
  }

  const valArr = val.indexOf(':') !== -1 ? val.split(':') : [val];

  // check mm and HH
  if (
    valArr[0] &&
    valArr[0].length &&
    (parseInt(valArr[0], 10) < 0 || parseInt(valArr[0], 10) > 23)
  ) {
    return false;
  }

  if (
    valArr[1] &&
    valArr[1].length &&
    (parseInt(valArr[1], 10) < 0 || parseInt(valArr[1], 10) > 59)
  ) {
    return false;
  }

  return true;
};

export const goTo = (history, path, state = null) => {
  if (history?.length > 0) {
    return history.goBack();
  }

  return history.push(path, state);
};

export const linkHistory = (history, path) => {
  if (history?.length > 0) {
  }

  return path;
};
